import Swiper from 'swiper';
import { Pagination, Autoplay, EffectFade } from 'swiper/modules';
// Swiper and modules styles
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/effect-fade';
export var HomeController = {
    init: function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            try {
                _this.initAboutUsSlider();
                _this.initSupportSlider();
                _this.initParallaxSections();
                _this.initVideoPopUp();
                resolve();
            }
            catch (error) {
                reject(error);
            }
        });
    },
    initAboutUsSlider: function () {
        var aboutUsContainer = document.querySelector('.about-us__slider');
        if (!aboutUsContainer) {
            return;
        }
        new Swiper(aboutUsContainer, {
            modules: [Pagination, Autoplay, EffectFade],
            autoplay: true,
            spaceBetween: 10,
            effect: 'fade',
            speed: 1400,
            fadeEffect: {
                crossFade: true,
            },
            loop: true,
            pagination: {
                el: '.about-us__slider--pagination',
                clickable: true,
            },
        });
    },
    initSupportSlider: function () {
        var supportContainer = document.querySelector('.support-slider');
        if (!supportContainer) {
            return;
        }
        new Swiper(supportContainer, {
            modules: [Pagination, Autoplay, EffectFade],
            autoplay: true,
            spaceBetween: 10,
            effect: 'fade',
            speed: 1400,
            fadeEffect: {
                crossFade: true,
            },
            loop: true,
            pagination: {
                el: '.support-slider--swiper-pagination',
                clickable: true,
            },
        });
    },
    initParallaxSections: function () {
        var sections = document.querySelectorAll('.contact-us .container, .hero-slider .container');
        function updateParallax() {
            sections.forEach(function (el) {
                var rect = el.getBoundingClientRect();
                var speed = 0.25; // parallax intensity
                var y = rect.top * speed;
                el.style.setProperty('--parallax-y', "".concat(y, "px"));
            });
            requestAnimationFrame(updateParallax);
        }
        requestAnimationFrame(updateParallax);
    },
    initVideoPopUp: function () {
        var modalEl = document.getElementById('videoModal');
        var contentEl = document.getElementById('videoModalContent');
        if (!modalEl || !contentEl)
            return;
        var modal = modalEl;
        var content = contentEl;
        var lastTrigger = null;
        function openModal(videoUrl, mimeType) {
            var video = document.createElement('video');
            video.controls = true;
            video.playsInline = true; // iOS
            video.preload = 'metadata';
            // Autoplay: It usually only works without sound.
            video.muted = true;
            video.autoplay = true;
            var source = document.createElement('source');
            source.src = videoUrl;
            if (mimeType)
                source.type = mimeType;
            video.appendChild(source);
            content.innerHTML = '';
            content.appendChild(video);
            modal.classList.add('is-open');
            modal.setAttribute('aria-hidden', 'false');
            document.documentElement.style.overflow = 'hidden';
            var p = video.play();
            if (p && typeof p.catch === 'function')
                p.catch(function () { });
        }
        function closeModal() {
            modal.classList.remove('is-open');
            modal.setAttribute('aria-hidden', 'true');
            content.innerHTML = ''; // remove player and stop the video
            document.documentElement.style.overflow = '';
            if (lastTrigger)
                lastTrigger.focus();
            lastTrigger = null;
        }
        document.addEventListener('click', function (e) {
            var target = e.target;
            if (!target)
                return;
            var trigger = target.closest('.video-trigger');
            if (trigger) {
                lastTrigger = trigger;
                var url = trigger.getAttribute('data-video-url');
                var type = trigger.getAttribute('data-video-type') || 'video/mp4';
                if (url)
                    openModal(url, type);
                return;
            }
            if (target.closest('[data-close]'))
                closeModal();
        });
        document.addEventListener('keydown', function (e) {
            if (e.key === 'Escape' && modal.classList.contains('is-open')) {
                closeModal();
            }
        });
    },
};
